import {NgModule}                   from '@angular/core';
import {RouterModule, Routes}       from '@angular/router';

import {LoginAdminComponent}        from "./admin/login/login-admin.component";
import {PageNotFoundComponent}      from './not-found.component';


const appRoutes: Routes = [
	{
		path: '',
		component: LoginAdminComponent,
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginAdminComponent
	},
	{
		path: 'pagenotfound',
		component: PageNotFoundComponent
	},
	{
		path: '**',
		component: PageNotFoundComponent,
	}
];


@NgModule({
	imports: [
		RouterModule.forRoot( appRoutes, { enableTracing: false, onSameUrlNavigation: "reload" } )
	],
	exports: [
		RouterModule
	]
})


export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts